export default {
  OPERACION_FICHA: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
